import PensiveRobotSvg from '@/assets/PensiveRobotSvg.svg';
import ButtonWithLoading from '@/components/ButtonWithLoading.comp.tsx';
import DialogMobile from '@/components/dialog/DialogMobile.tsx';
import { generateNonCachableImageSrc } from '@/utils/generateNonCachableImageSrc.util.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { QuizExpiredMessageProps } from '@/views/process/components/quizExpired/QuizExpiredMessageDesktop.tsx';
import React from 'react';

const QuizExpiredMessageMobile: React.FC<QuizExpiredMessageProps> = ({
  errorCode,
  handleBack,
  hideBackButton,
}) => {
  const { t } = useTranslationWithPrefix('views.process.409.' + errorCode);
  return (
    <div className="flex flex-column">
      <DialogMobile
        content={t('subMessage')}
        image={
          <img
            alt="love-robot"
            className="object-cover w-75 align-self-end"
            src={generateNonCachableImageSrc(PensiveRobotSvg)}
          />
        }
        message={t('title')}
      />
      {hideBackButton !== true && (
        <ButtonWithLoading onClick={handleBack}>{t('buttons.back')}</ButtonWithLoading>
      )}
    </div>
  );
};

export default QuizExpiredMessageMobile;
